module.exports = __webpack_public_path__ + "e42a5af907d37ed52a51d20c36cb7cb0.png";